import { yupResolver } from '@hookform/resolvers/yup'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { IoIosArrowBack } from 'react-icons/io'
import { Link } from 'react-router-dom'

import { Button } from '../components/Button'
import { HeaderLogo } from '../components/HeaderLogo'
import { Input } from '../components/Input'
import { resetPassword } from '../helpers/validationSchema'
import { forgotPassword } from '../services/auth'
import { handleError } from '../helpers/handleError'
import { toast } from 'react-toastify'

import Resetpassword from '../assets/svg/Resetpassword.svg?react'

interface FormValues {
  email: string
}

export const ResetPassword = () => {
  const [loading, setLoading] = useState<boolean>(false)

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    resolver: yupResolver(resetPassword),
  })
  const { t } = useTranslation()

  const onSubmit = (data: FormValues) => {
    forgotPassword({
      email: data.email,
    })
      .finally(() => {
        setLoading(true)
      })
      .then(() => {
        setLoading(false)
        toast.success(t('resetPasswordSuccess'))
      })
      .catch((er) => {
        setLoading(false)
        handleError(er)
      })
    reset()
  }

  return (
    <div className="flex font-sans">
      <div className="flex h-screen w-full flex-col px-6 py-6 sm:h-screen sm:w-[50%]">
        <HeaderLogo />
        <div className="mx-auto flex h-screen w-full flex-col justify-center lg:w-[60%]">
          <h2 className="mb-5 text-center text-lg font-[500] text-primary">
            {t('reset')}
          </h2>
          <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
            <Input
              variant={errors.email ? 'danger' : 'primary'}
              placeholder={t('emailPlaceholder')}
              type="text"
              helperText={errors.email?.message}
              {...register('email')}
            />
            <Button
              text={t('btnReset')}
              type="submit"
              className="text-white"
              loading={loading}
            />
          </form>
          <Link className="mt-7 text-base text-secondary" to="/">
            <div className="flex items-center text-center">
              <IoIosArrowBack />
              {t('btnBack')}
            </div>
          </Link>
        </div>
      </div>
      <div className="flex flex-col justify-center bg-[#407BFF] sm:h-screen sm:w-[50%]">
        <Resetpassword />
      </div>
    </div>
  )
}
